import { TextField } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'components/filter/from';
const FilterForm = ({ initialValues, defaultValues, processing, onSubmit, onClose }) => {
  const intl = useIntl();

  return (
    <Form
      header={<FormattedMessage id="header.user.filter" />}
      processing={processing}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      contentRenderer={(formik) => (
        <>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            id="firstname"
            name="firstname"
            label={intl.formatMessage({ id: 'user.firstname' })}
            value={formik.values.firstname}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.firstname && Boolean(formik.errors.firstname)}
            helperText={formik.touched.firstname && formik.errors.firstname}
          />
          <TextField
            fullWidth
            margin="dense"
            id="surname"
            name="surname"
            label={intl.formatMessage({ id: 'user.surname' })}
            value={formik.values.surname}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.surname && Boolean(formik.errors.surname)}
            helperText={formik.touched.surname && formik.errors.surname}
          />
          <TextField
            fullWidth
            margin="dense"
            id="email"
            name="email"
            label={intl.formatMessage({ id: 'user.email' })}
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </>
      )}
    />
  );
};

export default FilterForm;
